export default "__VITE_ASSET__4ElwthzA__"